import { useState, useMemo } from 'react';

//* HOC's
import { withUIContext } from 'context';

//* Components
import Text from 'components/common/Text';
import Button from 'components/common/Button';
import Container from 'components/common/Container';
import MultiTypeListItem from './MultiTypeListItem';

//* Styles
import MultiTypeListStyle from './style';

const MultiTypeList = ({ title, componentType = 'destinations', items, categories, first, winWidth }) => {
	//! States
	const [activeCat, setActiveCat] = useState();
	const [activePage, setActivePage] = useState(2);

	//! Items Per Page
	const itemsPerPage = useMemo(() => {
		return winWidth < 1024 ? 2 : winWidth < 1440 ? 3 : componentType === 'experiences' ? 4 : 3;
	}, [winWidth, componentType]);

	const [filteredItemsByActiveCategory, itemsHtml] = useMemo(() => {
		//! Checks
		const filteredItemsByActiveCategory = activeCat ? items.filter((i) => i.typeId === activeCat) : items;
		const filteredItemsByActivePage = filteredItemsByActiveCategory.slice(0, activePage * itemsPerPage);

		return [
			filteredItemsByActiveCategory,
			<Container
				row
				full
				className='mtli-container'>
				{filteredItemsByActivePage.map((i, k) => (
					<div
						key={`${i.typeId}-${i.id}`}
						className={`mtli-col col-${12 / itemsPerPage} col-ts-6 col-m-12`}>
						<MultiTypeListItem {...i} />
					</div>
				))}
			</Container>,
		];
	}, [activeCat, items, itemsPerPage, activePage]);

	const categoriesHTML = useMemo(() => {
		//! Checks
		const categoryIdsWithItems = new Set(items?.map((item) => item.typeId));
		const filteredCategories = categories?.filter((cat) => !cat.id || categoryIdsWithItems.has(cat.id));

		return filteredCategories?.length > 0 ? (
			<div className='mtl-cat-container'>
				{filteredCategories.map((cat, k) => (
					<Button
						key={k}
						icon={cat.iconName}
						color='ColorBigStone'
						className='mtl-cat-item'
						hoverColor='ColorBigStone'
						hoverBackground='ColorApricot'
						hoverBorderColor='ColorApricot'
						borderColor={(!cat.id && !activeCat) || cat.id === activeCat ? 'ColorApricot' : 'ColorWhite'}
						background={(!cat.id && !activeCat) || cat.id === activeCat ? 'ColorApricot' : 'ColorWhite'}
						onClick={() => {
							setActiveCat((prev) => (prev === cat.id ? null : cat.id));
							setActivePage(2);
						}}>
						{cat.name}
					</Button>
				))}
			</div>
		) : null;
	}, [activeCat, categories, items]);

	return items?.length > 0 ? (
		<Container
			section
			first={first}>
			<MultiTypeListStyle className={`${categories ? 'has-categories' : ''}`}>
				{title ? (
					<Text
						tag='h2'
						text={title}
						className={`mtl-title font-ping-bolder h3`}
					/>
				) : null}

				{categoriesHTML}

				{itemsHtml}

				{filteredItemsByActiveCategory?.length > activePage * itemsPerPage ? (
					<Button
						text='loadMore'
						color='ColorBigStone'
						background='transparent'
						hoverColor='ColorBigStone'
						borderColor='ColorBigStone'
						className='mtl-load-more-btn'
						hoverBorderColor='ColorApricot'
						hoverBackground='ColorApricot'
						onClick={() => setActivePage(activePage + 2)}
					/>
				) : null}
			</MultiTypeListStyle>
		</Container>
	) : null;
};

export default withUIContext(MultiTypeList, ['winWidth']);
